import React from 'react';
import SelectionCard from '../SelectionCard';

/**
 * StartingItemsSection - Select starting potion and class item
 */
function StartingItemsSection({ character, onUpdate, allData }) {
  // Hard-coded potions (standard starting options)
  const potions = [
    {
      id: 'minor-health-potion',
      name: 'Minor Health Potion',
      effect: 'Clear 1d4 Hit Points when consumed'
    },
    {
      id: 'minor-stamina-potion',
      name: 'Minor Stamina Potion',
      effect: 'Clear 1d4 Stress when consumed'
    }
  ];

  // Get class items from SRD class data, or fall back to equipment.classItems (for homebrew classes)
  const classData = character.class ? allData.classes?.[character.class] : null;
  const classItems = classData?.classItems || character.equipment?.classItems || [];

  function handlePotionSelect(potionId) {
    onUpdate({
      startingItems: {
        ...character.startingItems,
        potion: potionId
      }
    });
  }

  function handleClassItemSelect(item) {
    onUpdate({
      startingItems: {
        ...character.startingItems,
        classItem: item
      }
    });
  }

  return (
    <div className="space-y-6">
      {/* Standard Items Info */}
      <div className="p-4 bg-gradient-to-br from-gray-900 to-black border border-red-700 rounded-lg shadow-lg">
        <h4 className="font-semibold text-white mb-3">Your Standard Starting Inventory Includes:</h4>
        <ul className="space-y-2 text-gray-300 text-small">
          <li className="flex gap-2">
            <span className="text-primary">•</span>
            <span><strong className="text-gray-300">Torch</strong> (useful for illuminating a dark room)</span>
          </li>
          <li className="flex gap-2">
            <span className="text-primary">•</span>
            <span><strong className="text-gray-300">50 feet of rope</strong> (useful for climbing a wall or rappelling down a cliff)</span>
          </li>
          <li className="flex gap-2">
            <span className="text-primary">•</span>
            <span><strong className="text-gray-300">Basic supplies</strong> (tent, bedroll, tinderbox, rations, etc.)</span>
          </li>
          <li className="flex gap-2">
            <span className="text-primary">•</span>
            <span><strong className="text-gray-300">A handful of gold</strong> (automatically set in your character sheet)</span>
          </li>
        </ul>
      </div>

      {/* Potion selection */}
      <div>
        <h4 className="text-heading-sm text-red-400 font-serif mb-3">Choose Your Starting Potion</h4>
        <div className="grid gap-3 md:grid-cols-2">
          {potions.map((potion) => (
            <SelectionCard
              key={potion.id}
              title={potion.name}
              description={potion.effect}
              isSelected={character.startingItems?.potion === potion.id}
              onClick={() => handlePotionSelect(potion.id)}
              showDetails={false}
            />
          ))}
        </div>
      </div>

      {/* Class item selection */}
      {character.class && classItems.length === 2 && (
        <div>
          <h4 className="text-heading-sm text-red-400 font-serif mb-3">Choose Your Class Item</h4>
          <p className="text-gray-300 text-small mb-4">
            As a {classData?.name || character.class}, choose one of these items specific to your class:
          </p>
          <div className="grid gap-3 md:grid-cols-2">
            {classItems.map((item, idx) => (
              <SelectionCard
                key={idx}
                title={item}
                subtitle={`${classData?.name || character.class} item`}
                isSelected={character.startingItems?.classItem === item}
                onClick={() => handleClassItemSelect(item)}
                showDetails={false}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default StartingItemsSection;
